import router from "@/router";

import SecurityUseCase from "./SecurityUseCase";
import store from "@/store";
import TokenUseCase from "./TokenUseCase";

export default class LogoutTimer {
  public static timer?: NodeJS.Timeout;

  public static isUpdating = false;
  public static isResetting = false;

  resetTimer() {
    if (!LogoutTimer.isResetting) {
      LogoutTimer.isResetting = true;
      console.log("resetTimer...");
      LogoutTimer.clearTimer();

      LogoutTimer.timer = setInterval(async () => {
        // console.log(store.state.logoutTimeInSeconds);

        const logoutTime = await new TokenUseCase().getTokenExpiryTime();
        if (logoutTime) {
          /**
           * logoutTime is in UTC second
           * So we subtract the current UTC time in seconds
           * This gives the remaining time in seconds
           * Floor to get rid of decimal places. Logout early than late.
           */

          const remainingTime = Math.floor(logoutTime - Date.now() / 1000 - 10);
          store.commit("mutStoreLogoutTimeInSeconds", remainingTime);
          //console.log("Remaining Time", remainingTime);
          if (
            remainingTime <= 120 &&
            remainingTime > 0 &&
            !store.state.showLogoutDialog
          ) {
            console.log("logoutDialog...");
            if (!store.state.showLogoutDialog)
              store.dispatch("actionToggleShowLogoutDialog", true);
            console.log("logoutDialog...");
          }
          if (remainingTime <= 0 && LogoutTimer.timer) {
            // Navigate to the login page since the token has expired
            router.replace("/security/login");
            // We want the following to happen even if the logout fails
            // Hide the logout timer notification
            store.dispatch("actionToggleShowLogoutDialog", false);
            /**
             * Being able to calculate the remaingTime means
             * the token still exists and we need to logout
             * the  user
             */
            try {
              let securityUseCase = new SecurityUseCase();
              // Logout the user
              const _ = await securityUseCase.logout();
            } catch (error) {
              // If the logout fails, we still want to navigate to the login page
            }

            console.log("...logoutDialog");

            LogoutTimer.clearTimer();
          }
        }
      }, 1000);

      console.log("...resetTimer");
      LogoutTimer.isResetting = false;
    }
  }

  static clearTimer() {
    console.log("clearTimer...");
    if (LogoutTimer.timer) {
      clearInterval(LogoutTimer.timer);
      console.log("Timer Cleared");
    }
    console.log("...clearTimer");
  }

  public async updateToken() {
    if (!LogoutTimer.isUpdating) {
      LogoutTimer.isUpdating = true;
      console.log("updateToken...");
      const remainingTime = store.state.logoutTimeInSeconds;
      if (!remainingTime) {
        console.log("Reset Timer in updateToken");
        this.resetTimer();
      } else if (remainingTime > 120 && remainingTime < 300) {
        // If the remaining time is more than 2 minutes but less than 5 minutes
        // we update the token
        console.log("Updating Token in updateToken");
        const securityUseCase = new SecurityUseCase();
        await securityUseCase.updateToken();
      }

      console.log("...updateToken");
      LogoutTimer.isUpdating = false;
    }
  }
}
